import axios from 'axios';

const API_URL = '/api';

// Función para obtener avisos con filtros
export const getAvisos = async (filters = {}) => {
  try {
    const response = await axios.get(`${API_URL}/avisos`, { params: filters });
    return response.data;
  } catch (error) {
    console.error('Error al obtener avisos:', error);
    throw error;
  }
};

// Obtener ejecutivos para el filtro
export const getEjecutivos = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/ejecutivos`, { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener ejecutivos:', error);
    throw error;
  }
};

// Obtener medios para el filtro
export const getMedios = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/medios`, { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener medios:', error);
    throw error;
  }
};

// Obtener empresas clientes para el filtro
export const getEmpresasClientes = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/empresas-clientes`, { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener empresas clientes:', error);
    throw error;
  }
};

// Obtener estados de aviso para el filtro
export const getEstadosAviso = async () => {
  try {
    const response = await axios.get(`${API_URL}/estados-aviso`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener estados de aviso:', error);
    throw error;
  }
};

/**
 * Obtiene los datos para la comparativa de ventas entre dos años
 * @param {Object} params - Parámetros de búsqueda
 * @param {number} params.anioActual - Año actual para comparar
 * @param {number} params.anioAnterior - Año anterior para comparar
 * @returns {Promise<AxiosResponse>} - Respuesta de la API
 */
export const getComparativaVentas = async (params = {}) => {
  try {
    // Limpiar caché primero para asegurar datos frescos
    try {
      await axios.delete('/api/ventas/calculos-previos');
      console.log('Caché limpiada antes de obtener comparativa de ventas');
    } catch (cacheError) {
      console.warn('No se pudo limpiar la caché:', cacheError);
    }
    
    // Luego obtener los datos actualizados
    const response = await axios.get('/api/ventas/comparativa', { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener datos de comparativa:', error);
    throw error;
  }
}; 